/**
 * Tawk.to embed. Enabled only when USES_TAWK=true at build time (see vite.config.js).
 */
export function initTawkIfEnabled() {
    if (!import.meta.env.USES_TAWK) {
        return
    }
    window.Tawk_API = window.Tawk_API || {}
    window.Tawk_LoadStart = new Date()
    ;(function () {
        const s1 = document.createElement('script')
        const s0 = document.getElementsByTagName('script')[0]
        s1.async = true
        s1.src = 'https://embed.tawk.to/69f1ff3c214e0d1c316bec90/1jnckq144'
        s1.charset = 'UTF-8'
        s1.setAttribute('crossorigin', '*')
        s0.parentNode.insertBefore(s1, s0)
    })()
}
